import { render, staticRenderFns } from "./CollectionFollowResultAndNamePerformance.vue?vue&type=template&id=5ba64ebb&scoped=true"
import script from "./CollectionFollowResultAndNamePerformance.vue?vue&type=script&lang=js"
export * from "./CollectionFollowResultAndNamePerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionFollowResultAndNamePerformance.vue?vue&type=style&index=0&id=5ba64ebb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba64ebb",
  null
  
)

export default component.exports